/**
 * 市场时钟：A 股数据只在「交易时段 + 盘后 cron 落库窗口」变化，静默期把
 * staleTime 放大、轮询停摆——周末刷新首页不该重打几十个接口。
 *
 * 分档（本地时间=北京时间，自用假设成立）：
 * - 周末：至少 4h（周六中午的裁决/体检类 cron 影响的卡片极少，可接受）
 * - 交易日 09:00–15:10 盘中：用调用方 base（实时性优先）
 * - 交易日 15:10–23:30 盘后 cron 窗口：至少 10min（数据陆续落库，别太钝）
 * - 深夜/清晨（23:30–09:00）：至少 2h（夜间 cron 已收尾，早间 7:30 早报前基本冻结）
 * 节假日没接交易日历，按工作日的盘后档处理（略勤快但不出错）。
 */

export function isTradeWeekday(d: Date = new Date()): boolean {
  const w = d.getDay();
  return w >= 1 && w <= 5;
}

export function isMarketLive(d: Date = new Date()): boolean {
  if (!isTradeWeekday(d)) return false;
  const m = d.getHours() * 60 + d.getMinutes();
  return m >= 9 * 60 && m <= 15 * 60 + 10;
}

/** 按市场时段放大 staleTime（返回 ≥ base）。 */
export function marketStale(base: number, d: Date = new Date()): number {
  if (!isTradeWeekday(d)) return Math.max(base, 4 * 3600_000);
  const m = d.getHours() * 60 + d.getMinutes();
  if (m >= 9 * 60 && m <= 15 * 60 + 10) return base;
  if (m > 15 * 60 + 10 && m <= 23 * 60 + 30) return Math.max(base, 10 * 60_000);
  return Math.max(base, 2 * 3600_000);
}

/** 轮询间隔：闭市返回 false（React Query 语义 = 停轮询）。 */
export function liveInterval(ms: number, d: Date = new Date()): number | false {
  return isMarketLive(d) ? ms : false;
}

/** 北京时间的 YYYY-MM-DD；避免 toISOString() 在 00:00–08:00 返回前一天。 */
export function shanghaiDateKey(d: Date = new Date()): string {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Shanghai",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(d);
}
